<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <h3>{{ modalTitle }}</h3>
        <form @submit.prevent="submitForm">
          <div class="form-group">
            <label>Title <span class="text-danger">*</span></label>
            <input v-model="form.title" type="text" class="form-control" required>
          </div>

          <div class="form-group">
            <label>Details</label>
            <textarea v-model="form.details" class="form-control" rows="3"></textarea>
          </div>

          <div class="text-end mt-3">
            <button class="btn btn-primary" type="submit" :disabled="isSubmitting">
              {{ isSubmitting ? 'Saving...' : 'Save' }}
            </button>
            <button class="btn btn-secondary" type="button" @click="$emit('input', false)" :disabled="isSubmitting">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    category: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        title: '',
        details: ''
      },
      isSubmitting: false
    }
  },
  watch: {
    category: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.form = {
            title: newVal.title || '',
            details: newVal.details || ''
          }
        } else {
          this.resetForm()
        }
      }
    }
  },
  computed: {
    modalTitle() {
      return this.category ? 'Edit Category' : 'Add Category'
    }
  },
  methods: {
    resetForm() {
      this.form = {
        title: '',
        details: ''
      }
    },
    submitForm() {
      this.isSubmitting = true
      const url = this.category ? `/lead-categories/${this.category.id}` : '/lead-categories'
      const payload = this.category ? { ...this.form, _method: 'PUT' } : this.form

      axios.post(url, payload)
        .then(() => {
          this.$emit('input', false)
          this.$emit('saved')
          this.resetForm()
        })
        .catch(err => {
          console.error(err)
          alert('Error saving category')
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrapper {
  width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
}
</style>


